import { FunctionComponent, ReactNode, useMemo } from "react";

import CommunityContext, {
  Communities,
  createCycloneCommunityIndex,
} from "@context/context/community-context";

interface Props {
  currentOrigin: string;
  currentCommunityId: number;
  currentCycloneCommunityId: string;
  currentWpSiteId: number;
  communities: Communities;
  children?: ReactNode;
}

const CommunityProvider: FunctionComponent<Props> = ({
  children,
  currentOrigin,
  currentCommunityId,
  currentCycloneCommunityId,
  currentWpSiteId,
  communities,
}) => {
  const currentCommunity = communities[currentCommunityId];
  const cycloneCommunitiesById = useMemo(
    () => createCycloneCommunityIndex(communities),
    [communities],
  );

  if (!currentCommunity) {
    throw new Error(
      `Community not found for current communityId: ${currentCommunityId}`,
    );
  }

  return (
    <CommunityContext.Provider
      value={{
        currentCommunity,
        currentCommunityId,
        currentCycloneCommunityId,
        currentOrigin,
        currentWpSiteId,
        communities,
        cycloneCommunitiesById,
      }}
    >
      {children}
    </CommunityContext.Provider>
  );
};

export default CommunityProvider;
